import { Flex, List } from '@mantine/core'

import type { DonutChartLegendProps } from '@/components/@Shared/DonutChartLegend/DonutChartLegend.types'
import { Text } from '@/components/Text/Text'

import { CHART_COLORS } from '@/constants/chartColors.constants'

import classes from './DonutChartLegend.module.css'

export function DonutChartLegend({ chartData }: DonutChartLegendProps) {
  return (
    <List className={classes.list}>
      {chartData.map((data, index) => (
        <List.Item key={data.name}>
          <Flex align="center" gap={8}>
            <span
              className={classes.dot}
              style={{
                backgroundColor: CHART_COLORS[index],
              }}
            />
            <Text variant="body_4">
              {data.name} - {data.value}
            </Text>
          </Flex>
        </List.Item>
      ))}
    </List>
  )
}
